import React from 'react'
import {Global} from '@emotion/react'
import {getAssetUrl} from '@salesforce/pwa-kit-react-sdk/ssr/universal/utils'

const FontProvider = () => (
    <Global
        styles={`
            @font-face {
                font-family: 'crunchyrollatyp bold webfont woff';
                src: local('crunchyrollatyp bold webfont woff'),
                    url('${getAssetUrl(
                        'static/fonts/crunchyrollatyp-bold-webfont.woff'
                    )}') format('woff'),
            ...
            }
            @font-face {
                font-family: 'crunchyrollatyp bold';
                src: local('crunchyrollatyp bold webfont woff2'),
                    url('${getAssetUrl(
                        'static/fonts/crunchyrollatyp-bold-webfont.woff2'
                    )}') format('woff2'),
            ...
            }
            @font-face {
                font-family: 'crunchyrollatyp regular webfont woff';
                src: local('crunchyrollatyp regular webfont woff'),
                    url('${getAssetUrl(
                        'static/fonts/crunchyrollatyp-regular-webfont.woff'
                    )}') format('woff'),
            ...
            }
            @font-face {
                font-family: 'crunchyrollatyp normal';
                src: local('crunchyrollatyp regular webfont woff2'),
                    url('${getAssetUrl(
                        'static/fonts/crunchyrollatyp-regular-webfont.woff2'
                    )}') format('woff2'),
            ...
            }
            @font-face {
                font-family: 'Lato';
                src: url('${getAssetUrl('static/fonts/Lato-Regular.woff2')}') format('woff2'),
            }
            @font-face {
                font-family: 'Nutmeg';
                src: url('${getAssetUrl('static/fonts/Nutmeg-Regular.woff2')}') format('woff2'),
            }                
            @font-face {
                font-family: 'DM Sans';
                src: url('${getAssetUrl(
                    'static/fonts/dm-sans-latin-400-normal.woff2'
                )}') format('woff2');
               font-weight: 400;
               font-style: normal;
            }

            @font-face {
               font-family: 'DM Sans';
               src: url('${getAssetUrl(
                   'static/fonts/dm-sans-latin-700-normal.woff2'
               )}') format('woff2');
               font-weight: 700;
               font-style: normal;
            }

            @font-face {
               font-family: 'DM Sans';
               src: url('${getAssetUrl(
                   'static/fonts/dm-sans-latin-800-normal.woff2'
               )}') format('woff2');
               font-weight: 800;
               font-style: normal;
            }
        `}
    ></Global>
)

export default FontProvider
